import { render, staticRenderFns } from "./SingleSelection.vue?vue&type=template&id=4a1ec280"
import script from "./SingleSelection.vue?vue&type=script&lang=js"
export * from "./SingleSelection.vue?vue&type=script&lang=js"
import style0 from "./SingleSelection.vue?vue&type=style&index=0&id=4a1ec280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports